export const RealtimeV1CloseCode = {
  InvalidMessage: 4000,
  UnknownOperation: 4001,
  InvalidParams: 4002,
  InternalError: 5000,
} as const;
